import {create} from 'zustand';

export type DownloadStatus = 'downloading' | 'done' | 'error';

export type DownloadEntry = {
  progress: number;
  status: DownloadStatus;
};

type DownloadStoreState = {
  downloads: Record<string, DownloadEntry>;
  startDownload: (id: string) => void;
  updateProgress: (id: string, progress: number) => void;
  completeDownload: (id: string) => void;
  failDownload: (id: string) => void;
  clearDownload: (id: string) => void;
};

const downloadStore = create<DownloadStoreState>((set) => ({
  downloads: {},
  startDownload: (id) =>
    set((s) => ({
      downloads: {...s.downloads, [id]: {progress: 0, status: 'downloading'}},
    })),
  updateProgress: (id, progress) =>
    set((s) => ({
      downloads: {
        ...s.downloads,
        [id]: {progress, status: 'downloading'},
      },
    })),
  completeDownload: (id) =>
    set((s) => ({
      downloads: {...s.downloads, [id]: {progress: 100, status: 'done'}},
    })),
  failDownload: (id) =>
    set((s) => ({
      downloads: {...s.downloads, [id]: {progress: 0, status: 'error'}},
    })),
  clearDownload: (id) =>
    set((s) => {
      const next = {...s.downloads};
      delete next[id];
      return {downloads: next};
    }),
}));

export const downloadStoreActions = {
  startDownload: (id: string) => downloadStore.getState().startDownload(id),
  updateProgress: (id: string, progress: number) =>
    downloadStore.getState().updateProgress(id, progress),
  completeDownload: (id: string) =>
    downloadStore.getState().completeDownload(id),
  failDownload: (id: string) => downloadStore.getState().failDownload(id),
  clearDownload: (id: string) => downloadStore.getState().clearDownload(id),
};

export default downloadStore;
